<template>
  <div>
    <v-list>
      <v-list-tile
        
        
        v-for="(item, i) in items"
        :key="i"
        :to="item.route"
      >
        <v-list-tile-action>
          <v-icon light v-html="item.icon"></v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title v-text="item.title"></v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile class="hidden-sm-and-up" @click.prevent="logout">
        <v-list-tile-action>
          <v-icon light>account_box</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title v-text="$t('logout')"></v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </div>
</template>

<script>
export default {
  data () {
    return {
      name: this.$t('nav_menu_title'),
      items: [
        { title: 'My bookings', icon: 'dashboard', route: { name: 'bookings' } },
        { title: 'Personal information', icon: 'account_box', route: { name: 'profile' } },
        { title: 'Account settings', icon: 'settings', route: { name: 'settings.password' } }
      ]
    }
  },
  methods: {
    async logout () {
      this.busy = true

      // Log out the user.
      await this.$store.dispatch('logout')
      this.busy = false

      // Redirect to login.
      this.$router.push({ name: 'login' })
    }
  }
}
</script>



// WEBPACK FOOTER //
// NavMenu.vue?ef2e88e2